// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import routes from './routes/routes'
import VueRouter from 'vue-router'
import VueCookie from 'vue-cookie'
import i18n from './i18n'
import {store} from './store'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/common.css'
import 'vue-navigation-bar/dist/vue-navigation-bar.css'
import VueNavigationBar from 'vue-navigation-bar'
import BasicTable from '@/components/tables/BasicTable.vue'
import TableManager from '@/components/tables/TableManager'
import TableManagerBottom from '@/components/tables/TableManagerBottom'
import ReportHeader from '@/components/tables/ReportHeader'

import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import VueLineCharts from '@/pages/layout/lineChart.js'
import VueDoughnutCharts from '@/pages/layout/doughnutChart.js'

import api from '@/utils/api.js'

// MaterialDashboard plugin
import MaterialDashboard from './material-dashboard'

Vue.use(VueRouter)
Vue.use(MaterialDashboard)
Vue.use(BootstrapVue)
Vue.use(VueMoment, { moment })
Vue.use(VueCookie)
Vue.use(api)
Vue.use(require('vue-chartist'))
Vue.component('vue-navigation-bar', VueNavigationBar)
Vue.component('basic-table', BasicTable)
Vue.component('table-manager', TableManager)
Vue.component('table-manager-bottom', TableManagerBottom)
Vue.component('chartline-component', VueLineCharts)
Vue.component('chartdoughnut-component', VueDoughnutCharts)
Vue.component('report-header', ReportHeader)

export const cookie = VueCookie
export const router = new VueRouter({
  routes,
  linkExactActiveClass: 'nav-item active'
})

/* eslint-disable no-new */
export const vue = new Vue({
  el: '#app',
  render: h => h(App),
  router,
  api,
  store,
  i18n
})



// WEBPACK FOOTER //
// ./src/main.js